import React from 'react';
import { artifactStatusMap } from '../../../Constants/Files';
import { isTerminalStatus } from '../../../Utils/FileUtils';
import LiveStatusIndicator from '../LiveStatusIndicator';
// Artifact live status indicator component.
function ArtifactTerminalStatusIndicator({ artifact, platform }) {
	const status = artifact.status.toLowerCase();
	let liveIndicatorMsg = '';
	switch (status) {
		case artifactStatusMap.approved.value:
			liveIndicatorMsg = `Approved (Not Published)`;
			break;
		case artifactStatusMap.published.value:
			liveIndicatorMsg = `Published (Not Live)`;
			break;
		case artifactStatusMap.live.value:
			liveIndicatorMsg = `Live on ${platform}.`;
			break;
		default:
	}
	if (isTerminalStatus(status)) {
		return <LiveStatusIndicator message={liveIndicatorMsg} />;
	}
	return null;
}

export default ArtifactTerminalStatusIndicator;
